import { Add, Trash } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { optionLabel } from '../builderUtils';
import type { BuilderAction } from '../builderReducer';
import type { SurveyQuestion } from '@/api/surveys';
import type { ChangeEvent, Dispatch } from 'react';

interface OptionEditorProps {
    dispatch: Dispatch<BuilderAction>;
    question: SurveyQuestion;
    questionId: string;
}

export function OptionEditor({ dispatch, question, questionId }: OptionEditorProps) {
    const options = question.options ?? [];

    return (
        <div className="space-y-3 rounded-2xl border border-border/70 bg-surface/30 p-4">
            <div className="flex items-center justify-between gap-3">
                <div>
                    <Label>Opções</Label>
                    <p className="mt-1 text-xs text-muted-foreground">
                        Use pelo menos duas opções antes de publicar.
                    </p>
                </div>
                <Button
                    type="button"
                    variant="surface"
                    size="sm"
                    onClick={() => dispatch({ type: 'addOption', questionId })}
                >
                    <Add className="size-4" />
                    Opção
                </Button>
            </div>

            <div className="space-y-2">
                {options.map((option, optionIndex) => (
                    <div key={optionIndex} className="flex items-center gap-2">
                        <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-background text-xs font-semibold text-muted-foreground">
                            {optionIndex + 1}
                        </span>
                        <Input
                            value={optionLabel(option)}
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                dispatch({
                                    type: 'updateOption',
                                    questionId,
                                    optionIndex,
                                    value: event.target.value,
                                })
                            }
                            placeholder={`Opção ${optionIndex + 1}`}
                        />
                        <Button
                            type="button"
                            variant="ghost"
                            size="icon"
                            onClick={() =>
                                dispatch({
                                    type: 'deleteOption',
                                    questionId,
                                    optionIndex,
                                })
                            }
                            aria-label={`Excluir opção ${optionIndex + 1}`}
                        >
                            <Trash className="size-4" />
                        </Button>
                    </div>
                ))}
            </div>

            {question.field_type === 'select' ? (
                <label className="flex items-center gap-2 text-sm text-foreground">
                    <input
                        type="checkbox"
                        checked={Boolean(question.config?.allow_other)}
                        onChange={(event) =>
                            dispatch({
                                type: 'updateQuestion',
                                questionId,
                                patch: {
                                    config: { allow_other: event.target.checked },
                                },
                            })
                        }
                    />
                    Permitir resposta &quot;Outro&quot;
                </label>
            ) : null}
        </div>
    );
}
